export const API_KEY = '8D99688CC4FB8254C405008F25422A6D'
export const API_KEY_QUERY = '?apikey=' + API_KEY
export const API = process.env.API
export const BASE_URL = API
